import { ITranslationRequest } from "../base/translation";
export interface ICreateTradmarkManager {
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  address: string;
  phone: string;
  status: number;
  note: ITranslationRequest;
  trademarkId: number;
  imageId: number;
  password:string,
}

export interface IUpdateTradmarkManager extends ICreateTradmarkManager {}

export interface IExportTradeManagerExcel {
    id: boolean;
    trademarkName: boolean;
    firstName: boolean;
    lastName: boolean;
    status: boolean;
    createdAt: boolean;
    mobile: boolean;
  }
  export const columnsExportTradeManagerExcel = [
    "id",
    "trademarkName",
    "firstName",
    "lastName",
    "status",
    "createdAt",
    "mobile",
  ];